<template>
    <b-navbar toggleable="md" type="dark" variant="info">
        
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand v-on:click="toggle"><font-awesome-icon icon="sliders-h" /></b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav class="ml-auto">
        <b-navbar-nav right>
        <b-nav-item to="/home"><font-awesome-icon icon="map-marked-alt" /> Mappa</b-nav-item>
        <b-nav-item to="/dati"><font-awesome-icon icon="table" /> Dati</b-nav-item>
        <b-nav-item to="/report"><font-awesome-icon icon="file-invoice-dollar" /> Report</b-nav-item>
        </b-navbar-nav>

        <b-nav-item-dropdown right>
            <!-- Using button-content slot -->
            <template slot="button-content">
            <em>Profilo</em>
            </template>
            <b-dropdown-item v-if="this.$isAdmin" to="/usermanager">Gestione utenti</b-dropdown-item>
            <b-dropdown-item v-if="this.$isAdmin" to="/anagrafica">Carica Anagrafica</b-dropdown-item>
            <b-dropdown-item v-if="this.$isAdmin" to="/bilancio">Carica Bilancio</b-dropdown-item>
            <b-dropdown-item v-if="this.$isAdmin" to="/zona">Imposta zona</b-dropdown-item>
            <b-dropdown-item to="/profilo">Impostazioni profilo</b-dropdown-item>
            <b-dropdown-item v-on:click="logout">Esci</b-dropdown-item>
        </b-nav-item-dropdown>
        </b-navbar-nav>

    </b-collapse>
    </b-navbar>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'navbar',
    props: ['value'],
    methods: {
        logout() {
            Vue.http.post(this.$hostlink+'user/logout', {}, {credentials : true}).then(response => {
                if(response.body.success){
                    /*Vue.notify({
                        group: 'global',
                        title: 'Operazione eseguita',
                        text: 'Utente uscito con successo!',
                        type: 'success'
                    })*/
                    location.reload()
                }
            }, response => {
                // error callback
            })
        },
        toggle(){
            Vue.prototype.$sidebar.stato = !this.$sidebar.stato 
            this.$emit('input', this.$sidebar)
        }
    }
}
</script>
